import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';

import {Task} from './task';

@Injectable()
export class TaskService {

  constructor(private http: Http) {

  }

  getAll(page: number = 1, sort: string = '') {
    let currentfilter = JSON.parse(localStorage.getItem('filter'));
    if(!currentfilter) {
      currentfilter = {};
    }

    const params = new URLSearchParams();
    params.set('page',  page+'');
    params.set('sorts', sort);
    for (let key in currentfilter) {
      if(currentfilter[key]) {
        params.set('filter[' + key + ']', currentfilter[key])
      }
    }
    return this.http.get('tasks?' + params.toString()).map((response: Response) => response.json());
  }

  list(rowid: string = '') {
    return this.http.get('tasks/list/' + rowid).map((response: Response) => response.json());
  }

  getById(_id: string) {
    return this.http.get('tasks/' + _id).map((response: Response) => response.json());
  }

  getAllTasks() {
    return this.http.get('tasks/all').map((response: Response) => response.json());
  }

  getUsers() {
    return this.http.get('users/all').map((response: Response) => response.json());
  }
  
  getTeams(master_category_id: number = 0) {
    return this.http.get('teams/all/' + master_category_id).map((response: Response) => response.json());
  }

  getAllDepartments() {
    return this.http.get('departments/all').map((response: Response) => response.json());
  }

  getAllTaskCategories() {
    return this.http.get('taskcategories/all').map((response: Response) => response.json());
  }

  getTasks() {
    return this.http.get('tasks_settings/custom').map((response: Response) => response.json());
  }

  getUserTasks() {
      return this.http.get('tasks/usertasks').map((response: Response) => response.json());
  }

  getTaskUsers(_id: string) {
      return this.http.get('task/' + _id + '/users').map((response: Response) => response.json());
  }

  getTrashedById(_id: string) {
    return this.http.get('tasks/trashed/' + _id).map((response: Response) => response.json());
  }
  restoreTrashedById(_id: string) {
    return this.http.put('tasks/trashed/' + _id,{}).map((response: Response) => response.json());
  }

  create(task: Task) {
    return this.http.post('tasks', task).map((response: Response) => response.json());
  }

  update(task: Task) {
    return this.http.put('tasks/' + task.id, task).map((response: Response) => response.json());
  }

  delete(_id: string) {
    return this.http.delete('tasks/' + _id).map((response: Response) => response.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/views/management/tasks/task.service.ts